import { render, staticRenderFns } from "./EditStrategicValue.vue?vue&type=template&id=ba18b64c&scoped=true"
import script from "./EditStrategicValue.vue?vue&type=script&lang=js"
export * from "./EditStrategicValue.vue?vue&type=script&lang=js"
import style0 from "./EditStrategicValue.vue?vue&type=style&index=0&id=ba18b64c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba18b64c",
  null
  
)

export default component.exports